export const FilterAttributeType = {
  RANGE: 'range',
  VALUE: 'value',
  BOOLEAN: 'boolean',
  SORTBY: 'sortBy',
  ARRAY: 'array',
} as const;

export type FilterAttributeType = (typeof FilterAttributeType)[keyof typeof FilterAttributeType];

export const SortingOptionId = {
  NEWEST_FIRST: 'NEWEST_FIRST',
  PRICE_ASC: 'PRICE_ASC',
  PRICE_DESC: 'PRICE_DESC',
  RENT_ASC: 'RENT_ASC',
  RENT_DESC: 'RENT_DESC',
  LIVING_SURFACE_ASC: 'LIVING_SURFACE_ASC',
  LIVING_SURFACE_DESC: 'LIVING_SURFACE_DESC',
  TOTAL_SURFACE_ASC: 'TOTAL_SURFACE_ASC',
  TOTAL_SURFACE_DESC: 'TOTAL_SURFACE_DESC',
  PREFERENCES: 'PREFERENCES',
  SMART_SORT: 'SMART_SORT',
} as const;

export type SortingOptionId = (typeof SortingOptionId)[keyof typeof SortingOptionId];
